import React from "react"
import Wrapper from "../../components/Wrapper"
import Dispute from "../../components/dispute"

export default function DisputeEscalate() {
  return (
    <Wrapper>
      <Dispute status="escalated" name="escalated-dispute" />
    </Wrapper>
  )
}
